// extracted by mini-css-extract-plugin
module.exports = {"main":"PageWithHeroTemplate_main__2CYLT","sending":"PageWithHeroTemplate_sending__3YirZ"};